<template>
  <div class="mainbody edit_devi">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>客户管理</el-breadcrumb-item>
          <el-breadcrumb-item>编辑客户</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="content-box">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="客户信息" name="account">
            <div class="tab-content">
              <el-form
                ref="editForm1"
                :model="model"
                :rules="rules"
                :label-position="labelPosition"
                label-width="120px"
              >
                <el-form-item prop="companyFullName" label="客户全称">
                  <el-input
                    v-model="model.companyFullName"
                    placeholder="唯一名称，不可重复"
                  ></el-input>
                </el-form-item>

                <el-form-item prop="companyName" label="客户简称">
                  <el-input
                    v-model="model.companyName"
                    placeholder="唯一名称，不可重复"
                  ></el-input>
                </el-form-item>

                <el-form-item prop="companySuffix" label="客户后缀">
                  <el-input
                    v-model="model.companySuffix"
                    :disabled="model.id != '0'"
                    placeholder="唯一名称，不可重复、不可修改"
                  ></el-input>
                </el-form-item>

                <el-form-item label="登录账号">
                  admin@{{ model.companySuffix }}
                </el-form-item>

                <el-form-item prop="address" label="客户地址">
                  <el-input v-model="model.address" placeholder=""></el-input>
                </el-form-item>

                <el-form-item prop="contactName" label="联系人">
                  <el-input
                    v-model="model.contactName"
                    placeholder=""
                  ></el-input>
                </el-form-item>

                <el-form-item prop="contactMobile" label="联系电话">
                  <el-input
                    v-model="model.contactMobile"
                    placeholder=""
                  ></el-input>
                </el-form-item>

                <el-form-item prop="remark" label="备注">
                  <el-input v-model="model.remark" placeholder=""></el-input>
                </el-form-item>

                <el-form-item label="状态" v-show="false">
                  <el-radio-group v-model="model.status">
                    <el-radio-button label="0">正常</el-radio-button>
                    <el-radio-button label="1">冻结</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-form>
            </div>
            <div class="footer-box">
              <div class="footer-btn">
                <el-button type="primary" @click="submitForm('editForm')"
                  >确认保存</el-button
                >
                <el-button
                  type="warning"
                  @click="orderInvalid"
                  v-if="model.id != '0'"
                  >初始化密码</el-button
                >
                <el-button plain @click="resetForm">取消返回</el-button>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="关联" name="association" v-if="flag2">
            <div
              class="tab-content"
              style="display: flex; flex-direction: column"
            >
              <el-button
                style="width: 100px"
                type="primary"
                icon="el-icon-plus"
                @click="addChick()"
                >新增</el-button
              >
              <el-table :data="dataAppId" style="width: 100%">
                <el-table-column prop="appName" label="名称" width="100">
                </el-table-column>
                <el-table-column prop="appId" label="appId" width="200">
                </el-table-column>
                <el-table-column prop="appSecret" label="密钥" width="150">
                  <template slot-scope="scope">
                    <div class="secret-cell" :title="scope.row.appSecret">
                      <span class="ellipsis">{{ "......" }}</span>
                      <span class="tooltip">{{ scope.row.appSecret }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="username" label="用户名" width="120">
                </el-table-column>
                <el-table-column prop="realName" label="姓名" width="120">
                </el-table-column>
                <el-table-column label="是否可用" width="200">
                  <template slot-scope="scope">
                    <el-switch
                      :value="getStatus(scope.row.enable)"
                      active-text="开启"
                      inactive-text="禁用"
                      @change="handlePaymentChange(scope.row)"
                    >
                    </el-switch>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="150">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      icon="el-icon-edit"
                      title="编辑"
                      @click="update(scope.row)"
                    ></el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      title="删除"
                      icon="el-icon-delete"
                      @click="deleteItem(scope.row)"
                    ></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pager-box">
              <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-form :label-position="labelPosition" label-width="80px" :model="form">
        <el-form-item label="名称">
          <el-input v-model="form.appName"></el-input>
        </el-form-item>
        <el-form-item label="应用密钥">
          <el-input v-model="form.appSecret"></el-input>
        </el-form-item>
        <el-form-item label="用户名">
          <el-select v-model="value" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.username"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否启用">
          <el-switch v-model="delivery"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel()">取 消</el-button>
        <el-button type="primary" @click="save()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import "../../js/upload.component.js";
import { AxiosAjax } from "../../js/axios.config";
export default {
  data() {
    return {
      options: [],
      value: "",
      dialogVisible: false,
      form: {
        userId: "",
        appName: "",
        appSecret: "",
        enable: 0,
      },

      delivery: false,
      title: "添加",
      flag1: true,
      flag2: true,
      // dialogVisible: false,
      activeName: "account", //当前选项卡
      labelPosition: "right", //表单对齐方式
      siteList: [], //站点列表
      model: {
        gmtCreate: "2022-01-26 16:24:06",
        createdBy: "",
        modifiedBy: "",
        gmtModified: "2022-01-26 16:24:15",
        id: "0",
        companyType: 0,
        companyName: "",
        companyFullName: "",
        companySuffix: "",
        contactName: "",
        contactMobile: "",
        address: "",
        lat: "",
        lng: "",
        remark: "",
        remarkPic: "",
        logoPic: "",
        isDelete: false,
      },
      dataAppId: [],
      totalCount: 0,
      pageSize: 10,
      pageIndex: 1,

      // model1: {
      //   id: "",
      //   appId: "",
      //   sign: "",
      // },
      // rules1: {
      //   appId: [{ required: true, message: "必填项", trigger: "blur" }],
      //   sign: [{ required: true, message: "必填项", trigger: "blur" }],
      // },
      rules: {
        companyFullName: [
          { required: true, message: "必填项", trigger: "blur" },
        ],
        companyName: [{ required: true, message: "必填项", trigger: "blur" }],
        contactName: [{ required: true, message: "必填项", trigger: "blur" }],
        contactMobile: [{ required: true, message: "必填项", trigger: "blur" }],
        companySuffix: [
          { required: true, message: "请输入客户后缀", trigger: "blur" },
          {
            min: 2,
            max: 128,
            message: "长度在 3 到 128 个字符",
            trigger: "blur",
          },
          {
            pattern: /^[a-zA-Z0-9_]*$/,
            message: "只能是字母数字下划线",
            trigger: "blur",
          },
        ],
        phone: [
          {
            pattern: /^1[0-9]{10}$/,
            message: "手机号码格式不正确",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    // this.dataAppIdChange(this.dataAppId);
  },
  watch: {
    dataAppId: {
      handler(newData, oldData) {
        // this.dataAppIdChange(newData);
      },
      deep: true,
    },
  },

  methods: {
    cancel() {
      this.dialogVisible = false;
      this.inData();
    },
    user() {
      let _this = this;
      let sendUrl = "/cabinet/userApp/query/" + _this.$route.query.id;
      AxiosAjax({
        url: sendUrl,
        loading: true,
        success: function (res) {
          _this.options = res.data.data;
        },
      });
    },
    inData() {
      let _this = this;
      let sendUrl = "/cabinet/userApp/page";
      sendUrl += "?size=" + _this.pageSize;
      sendUrl += "&index=" + _this.pageIndex;
      sendUrl += "&id=" + _this.$route.query.id || "";

      AxiosAjax({
        url: sendUrl,
        loading: true,
        success: function (res) {
          _this.dataAppId = res.data.data.content;
          _this.totalCount = res.data.data.total;
          _this.pageIndex = res.data.data.index;
        },
      });
    },
    deleteItem(row) {
      let _this = this;
      this.$confirm("确认要删除该记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(function () {
        AxiosAjax({
          url: "/cabinet/userApp/" + row.appId,
          method: "delete",
          loading: true,
          success: function (res) {
            _this.$message({
              message: "操作成功",
              type: "success",
            });
            _this.inData();
          },
        });
      });
    },
    // dataAppIdChange(arr) {
    //   let flag = true;
    //   if (arr.length > 0) {
    //     arr.forEach((el) => {
    //       if (el.status == 1) {
    //         flag = false;
    //       }
    //     });
    //   }

    //   this.flag1 = flag ? true : false;
    // },
    getStatus(row) {
      return row === 1;
    },
    handlePaymentChange(row) {
      let _this = this;
      if (row.enable === 1) {
        row.enable = 0;
      } else {
        row.enable = 1;
      }
      AxiosAjax({
        url: "/cabinet/userApp/update",
        method: "put",
        data: row,
        loading: true,
        success: function (res) {
          _this.inData();
          _this.$message({
            message: "操作成功",
            type: "success",
          });
        },
      });
      //只能开启一个的逻辑
      // if (row.enable === 1) {
      //   this.dataAppId.forEach((el) => {
      //     if (el.id == row.id) {
      //       el.status = 0;

      //     }
      //   });
      // } else {
      //   let flag = true;
      //   this.dataAppId.forEach((el) => {
      //     if (el.status == 1) {
      //       flag = false;
      //     }
      //   });
      //   if (flag) {
      //     this.dataAppId.forEach((el) => {
      //       if (el.id == row.id) {
      //         el.status = 1;
      //       }
      //     });
      //   } else {
      //     this.$message({
      //       message: "已经开启一个了",
      //       type: "warning",
      //     });
      //   }
      // }
    },
    addChick() {
      this.title = "新增";
      this.dialogVisible = true;
    },
    update(row) {
      this.title = "修改";
      this.dialogVisible = true;
      this.form = row;
      this.value = row.userId;
      if (this.form.enable == 1) {
        this.delivery = true;
      } else {
        this.delivery = false;
      }
    },
    save() {
      let _this = this;
      if (this.title == "新增") {
        if (this.delivery) {
          this.form.enable = 1;
        } else {
          this.form.enable = 0;
        }
        this.form.userId = this.value;
        AxiosAjax({
          url: "/cabinet/userApp/save",
          method: "post",
          data: _this.form,
          loading: true,
          success: function (res) {
            _this.$message({
              message: "操作成功",
              type: "success",
            });
            _this.dialogVisible = false;
            _this.inData();
          },
        });
      } else if (this.title == "修改") {
        if (this.delivery) {
          this.form.enable = 1;
        } else {
          this.form.enable = 0;
        }
        this.form.userId = this.value;
        AxiosAjax({
          url: "/cabinet/userApp/update",
          method: "put",
          data: _this.form,
          loading: true,
          success: function (res) {
            _this.$message({
              message: "操作成功",
              type: "success",
            });
            _this.dialogVisible = false;
            _this.inData();
          },
        });
      }
      this.form = {};
      this.value = "";
      this.delivery = false;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
      this.inData();
    },

    //初始化数据
    initData: function () {
      let _this = this; //当前页面
      let id = _this.$route.query.id || ""; //获取ID
      if (id) {
        _this.flag2 = true;
        AxiosAjax({
          url: "/cabinet/company/" + id,
          loading: true,
          success: function (res) {
            //赋值给model
            Object.keys(_this.model).forEach((key) => {
              _this.model[key] = res.data.data[key];
            });
          },
        });
      } else {
        _this.flag2 = false;
      }
    },
    submitForm: function () {
      let _this = this; //当前页面
      //多个表单验证
      const f1 = new Promise((resolve, reject) => {
        _this.$refs["editForm1"].validate((valid) => {
          if (valid) resolve();
        });
      });

      Promise.all([f1]).then(() => {
        //提交表单,Id大于0则修改，否则添加
        if (_this.model.id > "0") {
          AxiosAjax({
            method: "put",
            url: "/cabinet/company/update",
            data: _this.model,
            loading: true,
            successMsg: "修改客户成功",
            success: function (res) {
              //可跳转加列表页
              _this.$router.push({ name: "Company" });
            },
          });
        } else {
          AxiosAjax({
            method: "post",
            url: "/cabinet/company/save",
            data: _this.model,
            loading: true,
            successMsg: "新增客户成功",
            success: function (res) {
              //重置表单
              //_this.$refs['editForm1'].resetFields();
              //可跳转加列表页
              _this.$router.push({ name: "Company" });
            },
          });
        }
      });
    },
    //初始账号
    orderInvalid: function () {
      let _parent = this; //父页面
      let _this = this; //当前页面
      //判断是否有父窗体
      if (typeof parent.vm != "undefined") {
        _parent = parent.vm;
      }
      //执行操作
      _parent
        .$confirm("确认要初始化密码为123456吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(function () {
          AxiosAjax({
            method: "put",
            url: "/cabinet/company/resetPassword/" + _this.model.id,
            loading: true,
            successMsg: "初始化已成功",
            success: function (res) {
              //_this.initData();//重新加载列表
            },
          });
        })
        .catch(function () {});
    },
    resetForm() {
      window.history.back(-1);
    },
    //每页显示数量
    handleSizeChange: function (val) {
      if (this.pageSize != val) {
        this.pageSize = val;
        this.inData();
      }
      //console.log('每页 ${val} 条');
    },
    //跳转到第几页
    handleCurrentChange: function (val) {
      if (this.pageIndex != val) {
        this.pageIndex = val;
        this.inData();
      }
      //console.log('当前页: ${val}');
    },
  },
  created: function () {
    //初始化数据
    this.initData();
    this.inData();
    this.user();
  },
};
</script>
<style scoped>
.edit_devi >>> .el-form-item__content {
  text-align: left !important;
}
.secret-cell {
  position: relative;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ellipsis {
  display: block;
}

.tooltip {
  visibility: hidden;
  background-color: black;
  color: white;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 150%;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
}

.secret-cell:hover .tooltip {
  visibility: visible;
  opacity: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/Company/CompanyEdit.vue